import type { LucideIcon } from "lucide-preact";
import { SelectedMark } from "./SettingsCard";

export type ThemeOptionButtonProps = {
  icon: LucideIcon;
  title: string;
  description: string;
  isSelected: boolean;
  onClick: () => void;
};

const SELECTED = "border-blue-500 bg-blue-50 dark:bg-blue-900/20";
const IDLE = "border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600";

export const ThemeOptionButton = ({ icon: Icon, title, description, isSelected, onClick }: ThemeOptionButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    class={`w-full flex items-center justify-between p-4 rounded-lg border-2 transition-all ${isSelected ? SELECTED : IDLE}`}
  >
    <div class="flex items-center space-x-3">
      <Icon class={isSelected ? "text-blue-600" : "text-gray-600 dark:text-gray-400"} size={24} />
      <div class="text-left">
        <div class="font-medium text-gray-900 dark:text-white">{title}</div>
        <div class="text-sm text-gray-600 dark:text-gray-400">{description}</div>
      </div>
    </div>
    {isSelected && <SelectedMark />}
  </button>
);
